var whitelabelPresenter = function whitelabelPresenter(whitelabel) {
  switch (whitelabel) {
    case 'getty':
      {
        return {
          brandName: 'Getty Images',
          faviconCdnUrl: 'https://cdn.bfldr.com/27C9EC93/at/s72qwp7m2c7v6m9vb4cngv5b/getty-images-favicon.ico',
          helpDocsBase: 'https://damhelp.gettyimages.com',
          iconCdnUrl: 'https://cdn.brandfolder.io/4OQZ5PW1/at/pygiaf-fhs49c-4he9f8/getty-images-icon.png',
          libraryName: {
            plural: 'Libraries',
            singular: 'Library'
          },
          logoCdnUrl: 'https://cdn.bfldr.com/27C9EC93/at/mnj7kp6q55hmn5c92qjfvjfc/getty-logo.png',
          platformName: 'Media Manager'
        };
      }
    default:
      {
        return {
          brandName: 'Brandfolder',
          faviconCdnUrl: 'https://cdn.bfldr.com/27C9EC93/at/gtw7psb5p5c79598r36n7fm/favicon-32x32.png?auto=webp',
          helpDocsBase: 'https://help.smartsheet.com/brandfolder',
          iconCdnUrl: 'https://cdn.bfldr.com/27C9EC93/at/q8y6v3-7yddcg-brgt1m/brandfolder-icon.svg',
          libraryName: {
            plural: 'Brandfolders',
            singular: 'Brandfolder'
          },
          logoCdnUrl: 'https://cdn.bfldr.com/27C9EC93/at/hf36pp9f9p46c9wpgr45shx/brandfolder-logo.svg',
          platformName: 'Brandfolder'
        };
      }
  }
};
export { whitelabelPresenter };